// extracted by mini-css-extract-plugin
export default {"popupsCheckout":"Wgh-I","popupContent":"WjcT0","page-head":"kn1bs"};